(function(){
  var root=document.getElementById('cp-vb'); if(!root) return;

  /* ---- variant + selling plan IDs. Same offer as the TSL arm. ---- */
  var CP={
    variants:{'1':'47590093881534','3':'47590093914302','6':'47590093947070'},
    plans:{'1':'15569387710','3':'15569486014','6':'15569518782'}
  };

  /* ---- test attribution: ?arm=b rides through to the order line ---- */
  var ARM=(function(){
    try{
      var v=new URL(window.location.href).searchParams.get('arm');
      return (v&&/^[a-z0-9_-]{1,24}$/i.test(v))?v:'b';
    }catch(e){return 'b'}
  })();

  var qty='3', sub=true;
  var tiers=[].slice.call(root.querySelectorAll('.tier'));
  var addBtn=root.querySelector('[data-add]');
  var btnLabel='';

  function money(v){return '$'+Number(v).toFixed(2)}
  /* cents math, identical to the TSL arm so both pages show the same figure */
  function total(each,n){return Math.round(each*100)*n/100}

  function render(){
    tiers.forEach(function(t){
      var on=t.dataset.qty===qty;
      t.classList.toggle('is-sel',on);
      t.setAttribute('aria-checked',on?'true':'false');
      var each=sub?Number(t.dataset.sub):Number(t.dataset.one);
      t.querySelector('[data-each]').textContent=money(each);
      var was=t.querySelector('[data-was]');
      was.style.visibility=sub?'visible':'hidden';
    });

    var bar=root.querySelector('[data-subbar]'),tog=root.querySelector('[data-toggle]');
    bar.classList.toggle('is-off',!sub);
    tog.setAttribute('aria-checked',sub?'true':'false');
    root.querySelector('[data-subword]').textContent=sub?'on':'off';

    var s=root.querySelector('.tier.is-sel'); if(!s) return;
    var each=sub?Number(s.dataset.sub):Number(s.dataset.one);
    var sum=total(each,Number(qty));
    btnLabel='Add to Cart \u2014 '+money(sum);
    if(!addBtn.disabled) addBtn.textContent=btnLabel;
    root.querySelector('[data-stickylabel]').textContent=s.querySelector('.qty').textContent;
    root.querySelector('[data-stickyprice]').textContent=money(each);
  }

  tiers.forEach(function(t){t.addEventListener('click',function(){qty=t.dataset.qty;render()})});
  root.querySelector('[data-toggle]').addEventListener('click',function(){sub=!sub;render()});

  /* ---- add to cart ---- */
  function busy(on){addBtn.disabled=on;addBtn.textContent=on?'Adding\u2026':btnLabel}

  addBtn.addEventListener('click',function(){
    var v=CP.variants[qty], plan=CP.plans[qty], err=root.querySelector('[data-err]');
    err.style.display='none';
    if(!v){err.textContent='That supply option is not connected yet.';err.style.display='block';return}
    var item={id:Number(v),quantity:1,properties:{'_lp':ARM}};
    if(sub&&plan)item.selling_plan=Number(plan);
    busy(true);
    var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
    fetch(r+'cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[item]})
    })
    .then(function(x){if(!x.ok)return x.json().then(function(d){throw d});return x.json()})
    .then(function(){
      /* mirror the arm onto the cart itself so it lands on the order too */
      return fetch(r+'cart/update.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({attributes:{'landing_page':ARM}})
      }).catch(function(){});
    })
    .then(function(){window.location.href=r+'checkout'})
    .catch(function(e){
      busy(false);
      err.textContent=(e&&e.description)?e.description:'We could not add that to your cart. Please try again.';
      err.style.display='block';
    });
  });

  /* ---- sticky bar ---- */
  (function(){
    var hero=root.querySelector('.hero'),bar=root.querySelector('[data-sticky]'),
        co=root.querySelector('#cp-offer');
    if(!hero||!bar||!('IntersectionObserver'in window))return;
    try{
      var pastHero=false,atOffer=false;
      function paint(){bar.classList.toggle('show',pastHero&&!atOffer)}
      new IntersectionObserver(function(e){pastHero=!e[0].isIntersecting;paint()},
        {rootMargin:'-120px 0px 0px 0px'}).observe(hero);
      if(co)new IntersectionObserver(function(e){atOffer=e[0].isIntersecting;paint()},
        {rootMargin:'0px 0px 0px 0px'}).observe(co);
    }catch(err){}
  })();

  render();
})();
